module.exports = __webpack_public_path__ + "img/manager.00472d7e.png";